import React, { useMemo } from "react";
import { Box } from "@material-ui/core";
import { useTranslation } from "core/hooks/use-translation.hook";
import { Table } from "core/components/Table";
import { useTabs } from "modules/sw-admin/hooks/use-tabs.hook";
import { useInstructors } from "modules/sw-admin/driving-schools/hooks/use-instructors.hook";
import Loader from "core/components/Loader";
import Text from "core/components/Text";
import { InstructorAccountType } from "modules/sw-admin/driving-schools/enums/instructor-account-type.enum";
import { ITableHeadCell } from "core/components/Table/TableHead";

const declinedTableHead: Array<ITableHeadCell> = [
    { translateKey: "driving-school" },
    { translateKey: "email-address" },
    { translateKey: "phone-number" },
    { translateKey: "zip-code" },
    { translateKey: "city" },
];

interface IDeclinedTableBody {
    id: string;
    drivingSchool: string;
    emailAddress: string;
    phoneNumber: string;
    zipCode: string;
    city: string;
}

export const DeclinedTable = () => {
    const { t } = useTranslation();

    const {
        tabActivePage,
        setTabActivePage,
    } = useTabs();

    const {
        data,
        isLoading,
        isFetchingNextPage,
    } = useInstructors({
        type: InstructorAccountType.DECLINED,
        searchParams: { page: tabActivePage }
    });

    const declinedTableBody: Array<IDeclinedTableBody> = useMemo(() => {
        if (!data?.items?.length) return [];

        return data.items.map(({ drivingSchool, ...instructor }) => ({
            id: instructor.id,
            drivingSchool: drivingSchool?.name,
            emailAddress: instructor.email,
            phoneNumber: drivingSchool?.phone,
            zipCode: drivingSchool?.postalCode,
            city: drivingSchool?.city,
        }));
    }, [data]);

    return (
        <>
            {isLoading ? (
                <Loader />
            ) : data?.items?.length > 0 ? (
                <Table<IDeclinedTableBody>
                    headProps={{
                        data: declinedTableHead,
                    }}
                    bodyProps={{
                        data: declinedTableBody,
                    }}
                    paginationProps={{
                        page: tabActivePage,
                        lastActivePage: data.currentPage,
                        pageSize: data.items.length,
                        totalPages: data.totalPages,
                        totalResults: data.totalResults,
                        isFetchingNextPage,
                        setPage: setTabActivePage,
                    }}
                />
            ) : (
                <Box mt="32px">
                    <Text>{t("no-data-available")}</Text>
                </Box>
            )}
        </>
    );
}
